import Svg from "./figs/Svg";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";

export default function ButtonProfile() {
  const { msg } = useSelector((s) => s.language);
  const path = useLocation();
  const showInPath = [];
  const noShowInPath = [
    "/",
    "/userVerify",
    "/resetPassword",
    "/createPassword",
  ];
  const onSignout = () => {
    localStorage.clear();
    window.location.replace("/");
  };
  if (noShowInPath.includes(path.pathname)) return null;
  return (
    <div className="__button_profile">
      <button>
        <Svg iconName="profile" className="w-full h-full" />
      </button>
      <div className="button_container">
        <button onClick={onSignout}>{msg.sign_out}</button>
      </div>
    </div>
  );
}
